// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.requestSection {
  background: #202437;
  margin-top: 16px;
  border-radius: 8px;
  padding-bottom: 20px;
}
.requestSection .tabDetailsSection table .table-body tr {
  background: rgba(43, 48, 69, 0.7);
}
.requestSection .MuiTabs-root {
  border-radius: 8px 8px 0 0;
}
.requestSection .MuiTabs-root .MuiTab-root {
  padding: 14px 31px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  font-family: "Poppins";
  font-weight: 400;
  text-transform: capitalize;
  line-height: 27px;
}
.requestSection .MuiTabs-root .MuiTab-root .MuiBox-root {
  display: flex;
  align-items: center;
}
.requestSection .MuiTabs-root .MuiTab-root .MuiBox-root img {
  margin-right: 16px;
}
.requestSection .MuiTabs-root .MuiTab-root .MuiBox-root span.count {
  font-weight: 700;
  margin-right: 5px;
  min-width: 20px;
}
.requestSection .MuiTabs-root .Mui-selected {
  background: rgb(32, 36, 55);
  border-top: 3px solid rgb(255, 139, 30);
  border-radius: 8px 8px 0 0;
}
.requestSection .MuiTabs-root .MuiTabs-indicator {
  background: none;
}
.requestSection .MuiTabs-root .MuiTabs-flexContainer {
  background: rgb(43, 48, 69);
}
.requestSection .tabDetailsSection {
  padding: 0px 12px 0px 0px;
  font-family: "Poppins";
}
.requestSection .tabDetailsSection .table-head {
  position: sticky;
  top: -1px;
  z-index: 1;
  background: #202437;
}
.requestSection .tabDetailsSection .table-body tr:hover {
  background: #28304C;
}
.requestSection .tabDetailsSection .table-body .selected {
  background: #28304C;
}
.requestSection .scheduled-flex {
  flex-direction: column;
  align-items: flex-start !important;
}
.requestSection .scheduled-flex .predict-wrapper span {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/RequestsSection/styles.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AAIgB;EACI,iCAAA;AAFpB;AAQI;EACI,0BAAA;AANR;AAQQ;EACI,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AANZ;AAQY;EACI,aAAA;EACA,mBAAA;AANhB;AAQgB;EACI,kBAAA;AANpB;AASgB;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;AAPpB;AAaQ;EACI,2BAAA;EACA,uCAAA;EACA,0BAAA;AAXZ;AAcQ;EACI,gBAAA;AAZZ;AAeQ;EACI,2BAAA;AAbZ;AAiBI;EACI,yBAAA;EACA,sBAAA;AAfR;AAiBQ;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAfZ;AAoBgB;EACI,mBAAA;AAlBpB;AAsBY;EACI,mBAAA;AApBhB;AAyBI;EACI,sBAAA;EACA,kCAAA;AAvBR;AA0BY;EACI,eAAA;AAxBhB","sourcesContent":[".requestSection {\r\n    background: #202437;\r\n    margin-top: 16px;\r\n    border-radius: 8px;\r\n    padding-bottom: 20px;\r\n\r\n    .tabDetailsSection {\r\n        table {\r\n            .table-body {\r\n                tr {\r\n                    background: rgba(43, 48, 69, 0.70);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .MuiTabs-root {\r\n        border-radius: 8px 8px 0 0;\r\n\r\n        .MuiTab-root {\r\n            padding: 14px 31px;\r\n            color: rgba(255, 255, 255, 0.7);\r\n            font-size: 18px;\r\n            font-family: 'Poppins';\r\n            font-weight: 400;\r\n            text-transform: capitalize;\r\n            line-height: 27px;\r\n\r\n            .MuiBox-root {\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                img {\r\n                    margin-right: 16px;\r\n                }\r\n\r\n                span.count {\r\n                    font-weight: 700;\r\n                    margin-right: 5px;\r\n                    min-width: 20px;\r\n                }\r\n            }\r\n\r\n        }\r\n\r\n        .Mui-selected {\r\n            background: rgba(32, 36, 55, 1);\r\n            border-top: 3px solid rgba(255, 139, 30, 1);\r\n            border-radius: 8px 8px 0 0;\r\n        }\r\n\r\n        .MuiTabs-indicator {\r\n            background: none;\r\n        }\r\n\r\n        .MuiTabs-flexContainer {\r\n            background: rgba(43, 48, 69, 1);\r\n        }\r\n    }\r\n\r\n    .tabDetailsSection {\r\n        padding: 0px 12px 0px 0px;\r\n        font-family: 'Poppins';\r\n\r\n        .table-head {\r\n            position: sticky;\r\n            top: -1px;\r\n            z-index: 1;\r\n            background: #202437;\r\n        }\r\n\r\n        .table-body {\r\n            tr {\r\n                &:hover {\r\n                    background: #28304C;\r\n                }\r\n            }\r\n\r\n            .selected {\r\n                background: #28304C;\r\n            }\r\n        }\r\n    }\r\n\r\n    .scheduled-flex {\r\n        flex-direction: column;\r\n        align-items: flex-start !important;\r\n\r\n        .predict-wrapper {\r\n            span {\r\n                font-size: 12px;\r\n            }\r\n        }\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
